<div class="placeholder-panel">
  <h2 class="placeholder-title">Devices</h2>
  <p class="placeholder-text">Coming soon — CMS device registration, search, and management.</p>
</div>
